interface Urls {
  REGISTER_USER: string;
  SEND_OTP: string;
  VALIDATE_OTP: string;
  REFRESH_TOKEN: string;
  GET_USER_PROFILE: string;
  GET_S3_FILE: (key: string) => string;
  UPDATE_USER_PROFILE: string;
  UPDATE_PROFILE_PIC: string;
  GET_WSM_SLOTS: string;
  GET_WSM_SLOT: (id: string) => string;
  GET_EXCLUSIVE_SLOT: string;
  GET_BULLETIN_SLOT: string;
  GET_COMING_UP_SLOTS: string;
  GET_UPCOMING_PASSES: string;
  GET_EXPERIENCE_PASSES: string;
  GET_USER_CREDITS: string;
  RESERVE_WSM_SLOT: string;
  UPDATE_RESERVATION: string;
  CANCEL_RESERVATION: string;
  GET_RESERVATIONS: string;
  GET_ALL_RESERVATIONS: string;
  GET_SLOT_RESERVATION: (id: string) => string;
  GET_MEMBERSHIP_LIST: string;
  GET_CREDIT_PLANS: string;
  GET_PASSES_LIST: string;
  CREATE_PAYMENT: string;
  VERIFY_PAYMENT: string;
  GET_PAYMENT_HISTORY: string;
  DOWNLOAD_INVOICE: (id: string) => string;
  GET_SCORE_CARD: string;
  GET_USER_SCORE_CARD: string;
  GET_USER_SCORE_CARD_RESULT: string;
  ADD_USER_SCORE_CARD: string;
  GET_CUSTOMER_LEAD: (token: string) => string;
  GET_PASSES: string;
  GET_MEMBERSHIP_BY_TYPE: string;
  SEND_EVENT_RESERVE_LEAD: string;
  GET_NEXT_AVAILABLE_SLOT: string;
  GET_EVENT_OFFERS: string;
  GET_EVENT_PASS_QUESTION: string;
  GET_PRODUCT: (type: string) => string;
}

export const getUrls = (): Urls => {
  const SERVICE_URL = process.env.REACT_APP_API_URL;
  return {
    REGISTER_USER: `${SERVICE_URL}/auth/register`,
    SEND_OTP: `${SERVICE_URL}/auth/send-otp`,
    VALIDATE_OTP: `${SERVICE_URL}/auth/validate-otp`,
    REFRESH_TOKEN: `${SERVICE_URL}/auth/refresh`,
    GET_USER_PROFILE: `${SERVICE_URL}/user`,
    GET_S3_FILE: (key) => `${SERVICE_URL}/s3/signed-url/${key}`,
    UPDATE_USER_PROFILE: `${SERVICE_URL}/user/update`,
    UPDATE_PROFILE_PIC: `${SERVICE_URL}/user/profile-picture`,
    GET_WSM_SLOTS: `${SERVICE_URL}/service-slots`,
    GET_WSM_SLOT: (id) => `${SERVICE_URL}/service-slots/${id}`,
    GET_EXCLUSIVE_SLOT: `${SERVICE_URL}/service-slots/exclusive`,
    GET_BULLETIN_SLOT: `${SERVICE_URL}/service-slots/bulletin`,
    GET_COMING_UP_SLOTS: `${SERVICE_URL}/service-slots/coming-up`,
    GET_UPCOMING_PASSES: `${SERVICE_URL}/service-slots/upcoming-passes`,
    GET_EXPERIENCE_PASSES: `${SERVICE_URL}/service-slots/experience-passes`,
    GET_USER_CREDITS: `${SERVICE_URL}/credits`,
    RESERVE_WSM_SLOT: `${SERVICE_URL}/reservations/reserve`,
    UPDATE_RESERVATION: `${SERVICE_URL}/reservations/update-pass`,
    CANCEL_RESERVATION: `${SERVICE_URL}/reservations/cancel`,
    GET_RESERVATIONS: `${SERVICE_URL}/reservations`,
    GET_ALL_RESERVATIONS: `${SERVICE_URL}/reservations/all`,
    GET_SLOT_RESERVATION: (id) => `${SERVICE_URL}/reservations/${id}`,
    GET_MEMBERSHIP_LIST: `${SERVICE_URL}/membership`,
    GET_CREDIT_PLANS: `${SERVICE_URL}/credit-plan`,
    GET_PASSES_LIST: `${SERVICE_URL}/full-day-pass`,
    CREATE_PAYMENT: `${SERVICE_URL}/payment/create-payment`,
    VERIFY_PAYMENT: `${SERVICE_URL}/payment/verify-payment`,
    GET_PAYMENT_HISTORY: `${SERVICE_URL}/payment`,
    DOWNLOAD_INVOICE: (id) => `${SERVICE_URL}/payment/${id}/invoice`,
    GET_SCORE_CARD: `${SERVICE_URL}/score-card`,
    GET_USER_SCORE_CARD: `${SERVICE_URL}/user-score-card`,
    GET_USER_SCORE_CARD_RESULT: `${SERVICE_URL}/user-score-card/result`,
    ADD_USER_SCORE_CARD: `${SERVICE_URL}/user-score-card/add`,
    GET_CUSTOMER_LEAD: (token) => `${SERVICE_URL}/lead/${token}`,
    GET_PASSES: `${SERVICE_URL}/pass`,
    GET_MEMBERSHIP_BY_TYPE: `${SERVICE_URL}/membership/type`,
    SEND_EVENT_RESERVE_LEAD: `${SERVICE_URL}/lead/send`,
    GET_NEXT_AVAILABLE_SLOT: `${SERVICE_URL}/service-slots/next-available`,
    GET_EVENT_OFFERS: `${SERVICE_URL}/offer/bulk`,
    GET_EVENT_PASS_QUESTION: `${SERVICE_URL}/slot-pass-question`,
    GET_PRODUCT: (type) => `${SERVICE_URL}/product/${type}`,
  };
};
